export enum HubParameters {
  None = 0,
  // eslint-disable-next-line no-bitwise
  Hidden = 1 << 0,
  BoundaryLocked = 1 << 1,
  Invalid = 1 << 2
}

export const HubParametersMapping: Record<HubParameters, string> = {
  [HubParameters.None]: 'None',
  [HubParameters.Hidden]: 'Hidden',
  [HubParameters.BoundaryLocked]: 'Boundary Locked',
  [HubParameters.Invalid]: 'Invalid'
};
